import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { downloadSwapTemplate } from "store/state/cashflows";

const DownloadSwapTemplate = props => (
  <SecondaryButton onClick={() => props.downloadSwapTemplate({ hedgeId: props.hedgeId })}>Swap Template</SecondaryButton>
);

export default connect(null, {
  downloadSwapTemplate
})
(DownloadSwapTemplate);
